<template>
  <v-breadcrumbs large :items="breadcrumbs"></v-breadcrumbs>
</template>



<script>
export default {
  name: "BreadCrumbs",
  props: {
    breadcrumbs: {
      type: Array,
      default: () => [],
    },
  },
};
</script>